import clickOutside from '../directives/click-outside';
import exercise from '../directives/exercise';
import exerciseMultiple from '../directives/exercise-multiple';
import lazyLoad from '../directives/lazy-load';

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
    install(app) {
        app.directive('click-outside', clickOutside);
        app.directive('exercise', exercise);
        app.directive('exercise-multiple', exerciseMultiple);
        app.directive('lazy-load', lazyLoad);
    },
};

export default GlobalDirectives;
